import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import Time from "../../Time/Time";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Formatter from "../../Localization/Formatter";
import TypeContainer from "../../Entity/Entities/Charge/Type/TypeContainer";
// import AgencyFeeContainer from "../../Entity/Entities/AgencyFee/AgencyFeeContainer";
// import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { ContactForContractInterface } from "../../Entity/Entities/ContactForContract/ContactForContractInterface";

class ContractExtendWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const previousContract: ContractInterface = this.component.props.app.contracts.filter((contract: ContractInterface) => contract.id === id)[0];

    // If contract is not found, redirect back
    if (!previousContract) {
      return this.component.redirectBack();
    }

    this.component.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_EXTEND_CLEAR
    });

    const usingBeta: boolean = this.component.props.app?.settings?.user?.beta;

    const state: any = {
      previousContract: previousContract,
      selectedTenant: previousContract?.tenant,
      selectedUnit: previousContract.unit,
      id: previousContract.id,
      note: previousContract.note,
      extensionDate: Time.firstDateNextMonth(),
      lastDate: previousContract?.lastDate,
      finalRentalPeriodDate: previousContract?.finalRentalPeriodDate,
      endDate: null,
      expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.component.props.app.settings.agency.notificationPeriod),
      beta: usingBeta ? usingBeta : null,
      defaultAgencyFees: !!previousContract.defaultAgencyFees[0] ? [previousContract.defaultAgencyFees[0]] : [],
      occupants: previousContract.occupants,
      ignoredPeople: [...previousContract.contractParties.map((contactForContract: ContactForContractInterface) => {
        return contactForContract.person;
      }), previousContract.person],
      additionalFields: previousContract.contractParties
                          .map((contactForContract: ContactForContractInterface) => {
                            return {
                              selectedPerson: contactForContract.person,
                              description: contactForContract.description,
                              contactForContractTypeId: contactForContract.type.getValue()
                            };
                          }),
      autoSendInvoiceToTenant: previousContract?.autoSendInvoiceToTenant,
      addressForRentEmail: previousContract?.addressForRentEmail,
      isCommercial: previousContract?.isCommercial,
      isPaidDirectlyToOwner: previousContract?.chargeTemplates?.every(template => template.isPaidDirectlyToOwner),
    };

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const savedData = {...this.component.props.app.savedDataBeforeRedirecting.dataToBeSaved};
      const savedPeople = !!this.component.props.app.savedDataBeforeRedirecting.dataToBeSaved.ignoredPeople &&
                          this.component.props.app.savedDataBeforeRedirecting.dataToBeSaved.ignoredPeople ?
                            [...this.component.props.app.savedDataBeforeRedirecting.dataToBeSaved.ignoredPeople] :
                            [];
      const createdPerson = this.component.props.app.savedDataBeforeRedirecting.createdPerson ?
                              this.component.props.app.savedDataBeforeRedirecting.createdPerson :
                              null;
      const ignoredPeople = createdPerson ? [{...createdPerson}, ...savedPeople] : [...savedPeople];
      const createdUnit = this.component.props.app.savedDataBeforeRedirecting.createdUnit ?
                            this.component.props.app.savedDataBeforeRedirecting.createdUnit :
                            null;

      savedData.ignoredPeople = [...ignoredPeople];

      if (createdPerson) {
        savedData.selectedTenant = createdPerson;
      }

      if (createdUnit) {
        savedData.selectedUnit = createdUnit;
      }

      savedData.lastSelectedIndex = null;

      this.component.setState({
        ...state,
        ...savedData
      }, () => this.component.setState({hasModifiedData: true}));
    } else {
      let chargeTemplates = [];

      previousContract.chargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => {
          return !!chargeTemplate && (chargeTemplate.type.id !== TypeContainer.pickIdFromLabel("Deposit"));
        })
        .forEach(template => {
          let chargeTemplate = {
              amount: parseFloat(Formatter.simpleFormatNumber(template.amount).replace(",", ".")),
              currency: template.currency.getCurrencyId(),
              currencyId: template.currency.getCurrencyId(),
              type: template.type.id,
              chargeClassId: template.type.chargeClassId,
              repeatPeriod: template.repeatPeriod.id,
              repeatPeriodId: template.repeatPeriod.id,
              description: template.description,
              paymentOffset: template.paymentOffset?.getValue(),
              dueDateFirstPayment: Time.firstDateNextMonth(),
              firstDate: Time.firstDateNextMonth(),
              endDate: null,
              isDefault: false,
              oldAmount: parseFloat(Formatter.simpleFormatNumber(template.amount).replace(",", ".")),
              isPaidDirectlyToOwner: template.isPaidDirectlyToOwner,
              contactId: template.contactId,
              companyId: template.companyId,
              isCollective: template?.isCollective
            }
            chargeTemplates.push(chargeTemplate);
          });

        this.component.setState({
          chargeTemplates: chargeTemplates,
          ...state,
        })

    }
  }
}

export default new ContractExtendWillMount();
